module.exports = __webpack_public_path__ + "img/screen-users.8c1230af.svg";